import React, { useEffect, useState } from 'react'
import moment from 'moment-timezone'

import {
  DatePicker,
  Select,
  Row,
  Col,
  notification,
  Button,
  Input,
  Form,
  InputNumber,
  Drawer,
} from 'antd'

//apis
import { addVoucher, updateVoucher } from 'apis/voucher'
import { getCountries } from 'apis/country'
import { useSelector } from 'react-redux'
const { Option } = Select
export default function VoucherGiftForm({ reload, record, children }) {
  const [form] = Form.useForm()
  const dataUser = useSelector((state) => state.login.dataUser)

  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [isVisible, setIsVisible] = useState(false)

  const toggle = () => {
    setIsVisible(!isVisible)
  }

  const _getCountries = async () => {
    try {
      setLoading(true)
      const res = await getCountries({})
      if (res.status === 200) {
        setCountries(res.data.data)
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }
  const onFinish = async (formData) => {
    try {
      await form.validateFields()

      const body = {
        ...formData,
        paypal_order_id: '',
        is_gift: true,
        user_id: -1,
      }

      console.log(body)
      setLoading(true)
      let res
      if (record) res = await updateVoucher(record.promotion_id, body)
      else res = await addVoucher(body)
      console.log(res)
      setLoading(false)

      if (res.status === 200) {
        if (res.data.success) {
          reload()
          toggle()
          notification.success({
            message: `${record ? 'Cập nhật' : 'Thêm'} voucher tặng thành công`,
          })
        } else
          notification.error({
            message:
              res.data.message ||
              `${record ? 'Cập nhật' : 'Thêm'} voucher tặng thất bại, vui lòng thử lại`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${record ? 'Cập nhật' : 'Thêm'} voucher tặng thất bại, vui lòng thử lại`,
        })
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isVisible) {
      if (record) form.setFieldsValue({ ...record })
    } else form.resetFields()
  }, [isVisible])
  useEffect(() => {
    _getCountries()
  }, [])

  return (
    <>
      <div onClick={() => setIsVisible(true)}>{children}</div>
      <Drawer
        visible={isVisible}
        onClose={toggle}
        title={record ? 'Cập nhật khuyến mãi' : 'Tạo voucher tặng'}
        width="60%"
      >
        <Form onFinish={onFinish} form={form} layout="vertical">
          <Row gutter={30}>
            <Col span={24}>
              <Row wrap={false} justify="space-between">
                <Form.Item name="email" label="Email" style={{ width: '48%' }}>
                  <Input placeholder="Nhập email" size="large" />
                </Form.Item>

                <Form.Item name="phone" label="Số điện thoại" style={{ width: '48%' }}>
                  <Input placeholder="Nhập số điện thoại" size="large" />
                </Form.Item>
              </Row>
              <Row wrap={false} justify="space-between">
                <Form.Item
                  style={{ width: '48%' }}
                  name="type"
                  initialValue="value"
                  label="Loại giảm giá"
                >
                  <Select placeholder="Loại giảm giá" size="large">
                    <Option value="value">Giá trị</Option>
                    <Option value="percent">Phần trăm</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  rules={[{ message: 'Vui lòng nhập giá trị', required: true }]}
                  name="final_cost"
                  label="Giá trị"
                  style={{ width: '48%' }}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    placeholder="Nhập giá trị"
                    size="large"
                  />
                </Form.Item>
              </Row>
              <Form.Item
                style={{ width: '48%' }}
                name="currency"
                initialValue="currency"
                label="Chọn đơn vị tiền tệ"
              >
                <Select placeholder="Đơn vị tiền tệ" size="large">
                  {countries.map((country) => {
                    return (
                      <Option value={country.currency}>
                        {country.name + ' (' + country.currency + ')'}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>

              <Row wrap={false} justify="space-between">
                <Form.Item
                  rules={[{ message: 'Nhập số tiền áp dụng tối đa', required: true }]}
                  name="limit_apply"
                  label="Số tiền áp dụng tối đa"
                  style={{ width: '48%' }}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    placeholder="Nhập giá trị"
                    size="large"
                  />
                </Form.Item>

                <Form.Item
                  rules={[{ message: 'Nhập số tiền áp dụng tối thiểu', required: true }]}
                  name="minium_apply"
                  label="Đơn hàng tối thiểu được áp đụng"
                  style={{ width: '48%' }}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    placeholder="Nhập giá trị"
                    size="large"
                  />
                </Form.Item>
              </Row>

              <br />
            </Col>
          </Row>
          <Form.Item
            rules={[{ message: 'Vui lòng chọn ngày hết hạn', required: true }]}
            style={{ width: '48%' }}
            name="date_expire"
            label="Ngày hết hạn"
          >
            <DatePicker placeholder="Chọn ngày hết hạn" size="large" style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item>
            <Button
              loading={loading}
              size="large"
              type="primary"
              htmlType="submit"
              style={{ width: 120 }}
            >
              {record ? 'Cập nhật' : 'Tạo'}
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}
